import React, { useEffect } from 'react'
import ReuseEmbroideryInfoPage from './ReuseEmbroideryInfoPage'
import "./styles/_index.scss"
import queryString from 'query-string'

const ReuseEmbroideryInfoContainer = (props) => {
    const { location } = props.history
    let params = {}

    if (location.search !== '') {
        params = queryString.parse(location.search)
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            const url = new URL(window.location.href)
            url.search = ""
            window.history.replaceState({}, document.title, url.pathname)
        }, 0)

        return () => clearTimeout(timer)
    }, [])

    return (
        <div className="ReuseEmbroideryInfoContainer">
            <ReuseEmbroideryInfoPage params={params} />
        </div>
    )
}

export default ReuseEmbroideryInfoContainer